import React, { useState } from 'react';
import { AGENDADA } from '../../../../data/audienceStates';
import { Button } from 'react-bootstrap';
import { ICON_EDIT } from '../../../extras/icons';
import OperatorEditForm from './forms/OperatorEditForm';
import { useSelector } from 'react-redux';
import AuthoritiesService from '../../../../services/AuthoritiesService';
import { SOLICITUDES_MODIFICAR } from '../../../../data/objects';
//Función principal
const AudienceOperator = props => {
    //Tomo los props
    const { audience } = props;
    //Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [showEdit, setShowEdit] = useState(false);
    //Manejo la apertura
    const handleOpen = () => {
        setShowEdit(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShowEdit(false);
    }
    //Analizo si puede editar
    let canEdit = false;
    if(audience){
        if(audience.estado && audience.estado.id == AGENDADA){
            //Verifico permisos
            if(authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_MODIFICAR)){
                //Puede editar
                canEdit = true;
            }
        }
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">OPERADOR / AUDIENCISTA</h6>
                    <div className="dropdown no-arrow">
                        {
                            canEdit ? (
                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpen}>
                                    <ICON_EDIT />
                                </Button>
                            ) : null
                        }

                        <OperatorEditForm
                            show={showEdit}
                            handleClose={handleClose}
                            audience={audience}
                        />
                    </div>
                </div>
                <table className="table table-hover table-sm">
                    <thead className="thead-light">
                        <tr>
                            <th className="text-center">Apellido y Nombre</th>
                            <th className="text-center">Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            audience.operador ? (
                                <tr>
                                    <td className="align-middle text-center">
                                        { `${audience.operador.apellido}, ${audience.operador.nombre}` }
                                    </td>
                                    <td className="align-middle text-center">
                                        { audience.operador.email }
                                    </td>
                                </tr>
                            ) : null
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AudienceOperator;